import { Box, Spinner } from '@core/ui-elements'

export default function LoadingScreen() {
  return (
    <Box alignItems="center" display="flex" h="100dvh" justifyContent="center">
      <Spinner />
    </Box>
  )
}
